import { Fueling } from './fueling';
import { FuelingMergeBase } from './fueling-merge-base';
import { MergeStatusSeverity } from './merge-status-severity';
import { FuelingInformationStatus } from './fueling-information-status';
import {FuelingMergeAuxiliaryCommonLogic} from './fueling-merge-auxiliary-common-logic';
import { FuelingStationEvent } from './fueling-station-event';

export class FuelingMerge extends FuelingMergeBase {
  fuelingEventsDc: Fueling[];
  fuelingEventsFc: Fueling[];
  fuelingMergeId: number;
  unitId: number;
  unitName: string;
  isPremerged: boolean;
  isApproved: boolean;
  isUserTouched: boolean;
  markedAsNotReal: boolean;
  fuelingEventsFcCount: number;
  fuelingEventsDcCountCount: number;
  ventPrediction: FuelingInformationStatus;
  eventAtPossibleSources: number[];
  fuelChangeLitersPossibleSources: number[];
  driverNamePossibleSources: number[];
  positionPossibleSources: number[];
  fuelChangeLitersPositive: boolean;
  auxiliary: FuelingMergeAuxiliaryCommonLogic;
  fuelingStationEvent: FuelingStationEvent;
  system: boolean;
  import: boolean;
  fuelingStationName: string;
  warehouseSupervisorCardNumber: any;
  driverFuelingCode: any;
  get isCorrect(): boolean {
    return !this.markedAsNotReal;
  }
  set isCorrect(value: boolean) {
    this.markedAsNotReal = !value;
  }
  static copy(source: FuelingMerge, target: FuelingMerge) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  }
}
